
import { useEffect, useState } from 'react';
import { ActivityIndicator } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { fetchBookedSlots, deleteBooking } from '../common/api';
import { formatDateForApi } from '../common/date';
import { i18n } from "../common/localization";
import { styles } from "../common/styles";
import { BookingListBox } from './BookingListBox';
import { InfoModal } from "../common/InfoModal";


const BookedReservations = ({ type: propType }) => {
  const route = useRoute();
  const type = propType || (route.params && route.params.type);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorModalVisible, setErrorModalVisible] = useState(false);


  useEffect(() => {
    (async () => {
      try {
        const data = await fetchBookedSlots(type);
        setBookings(data);
      } catch (e) {
        setErrorModalVisible(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [type]);

  if (loading) return <ActivityIndicator style={styles.reservationsBox} />;

  return (
    <>
      <BookingListBox
        isBooking={false}
        data={bookings}
        title={i18n.t('yourReservations')}
        actionLabel={i18n.t('delete')}
        onItemAction={async (item) => {
          const date = formatDateForApi(new Date(item.Start * 1000));
          await deleteBooking(item.LessonID, date);
          setBookings(prev =>
            prev.filter(b => b.LessonID !== item.LessonID)
          );
        }}
      />
      <InfoModal
      visible={errorModalVisible}
      onPressClose={() => setErrorModalVisible(false)}
      text={i18n.t('noReservations')}
      isError={true}
    />
  </>
  );
};

export default BookedReservations;
